const pad = (n) => String(n).padStart(2, "0");
const NOW = new Date();
const ABBR = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
const FULL = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
export const TODAY = `${NOW.getFullYear()}-${pad(NOW.getMonth() + 1)}-${pad(NOW.getDate())}`;
export const MONTH_KEY = TODAY.slice(0, 7);
export const MONTH_LABEL = `${FULL[NOW.getMonth()]} ${NOW.getFullYear()}`;
export const MONTHS = Array.from({ length: 6 }, (_, i) => ABBR[(NOW.getMonth() - 5 + i + 12) % 12]);

export const PROFILES = { master: {}, empresaria: {}, colaboradora: {} };
const TITLES = { master: "Consultora Master", empresaria: "Empresária", colaboradora: "Colaboradora" };
export const setProfile = (user) => {
  PROFILES[user.role] = { name: user.name, title: TITLES[user.role], avatar: null, companyId: user.companyId, collaboratorId: user.collaboratorId };
};

const companies = [
  { id: "e1", name: "Bella Estética", segment: "Clínica de Estética", owner: "Juliana Martins", city: "São Paulo · SP", since: "Mar 2025", salesGoal: 110000, history: [82000, 88000, 91500, 97000, 101000] },
  { id: "e2", name: "Ateliê Flor de Lis", segment: "Moda Feminina", owner: "Carolina Souza", city: "Curitiba · PR", since: "Jun 2025", salesGoal: 70000, history: [52000, 55000, 58500, 61000, 63000] },
  { id: "e3", name: "Doce Encanto", segment: "Confeitaria", owner: "Renata Lima", city: "Belo Horizonte · MG", since: "Jan 2026", salesGoal: 42000, history: [30000, 32500, 34000, 36500, 38000] },
  { id: "e4", name: "Studio Glam", segment: "Salão de Beleza", owner: "Patrícia Alves", city: "Recife · PE", since: "Ago 2025", salesGoal: 80000, history: [62000, 66000, 64000, 70000, 72000] },
];

const collabSeed = [
  ["c1", "e1", "Ana Clara Rocha", "Esteticista", 28000, 0.96],
  ["c2", "e1", "Beatriz Nunes", "Recepção e Vendas", 22000, 1.04],
  ["c3", "e1", "Camila Ferreira", "Esteticista", 26000, 0.78],
  ["c4", "e1", "Daniela Prado", "Consultora de Vendas", 30000, 0.88],
  ["c5", "e2", "Elaine Costa", "Vendedora", 25000, 0.92],
  ["c6", "e2", "Gabriela Mota", "Vendedora", 24000, 0.81],
  ["c7", "e2", "Helena Duarte", "Costureira", 15000, 1.01],
  ["c8", "e3", "Isabela Ramos", "Confeiteira", 18000, 0.97],
  ["c9", "e3", "Larissa Teixeira", "Atendente", 20000, 0.86],
  ["c10", "e4", "Mariana Lopes", "Cabeleireira", 30000, 0.9],
  ["c11", "e4", "Natália Vieira", "Manicure", 20000, 1.06],
  ["c12", "e4", "Olívia Santos", "Recepção", 25000, 0.74],
];

const FACT = [0.8, 1, 1.2, 0.8, 1, 1.2, 0.8, 1.2];
const TASKS = ["Confirmar agendamentos do dia", "Organizar estoque de produtos", "Enviar mensagens de pós-venda", "Atualizar quadro de metas", "Higienizar equipamentos e bancada", "Registrar fechamento do caixa"];
const TIMES = ["08:30", "10:00", "13:00", "15:30", "17:45"];
const PRIORITIES = ["Alta", "Média", "Baixa", "Média", "Alta"];

export const CHECKLISTS = [
  { title: "Abertura do expediente", period: "Manhã", items: ["Ligar sistemas e conferir agenda", "Conferir limpeza do ambiente", "Verificar itens essenciais em estoque", "Revisar metas do dia"] },
  { title: "Padrão de atendimento", period: "Durante o dia", items: ["Receber com boas-vindas personalizadas", "Apresentar serviço ou produto complementar", "Registrar a venda no sistema da empresa", "Agradecer e convidar para retorno"] },
  { title: "Fechamento do expediente", period: "Noite", items: ["Informar total de vendas do dia", "Organizar a área de trabalho", "Desligar equipamentos", "Reportar pendências à gestora"] },
];

const PROCESSES = [
  { name: "Atendimento: do primeiro contato ao pós-venda", area: "Comercial", status: "Ativo", steps: ["Acolhimento", "Entendimento da necessidade", "Apresentação da solução", "Fechamento", "Pós-venda em 48h"] },
  { name: "Gestão de estoque e reposição", area: "Operacional", status: "Ativo", steps: ["Contagem semanal", "Lista de reposição", "Aprovação da gestora", "Pedido ao fornecedor", "Conferência na entrega"] },
  { name: "Integração de nova colaboradora", area: "Pessoas", status: "Em revisão", steps: ["Boas-vindas e cultura", "Apresentação dos processos", "Treinamentos obrigatórios", "Acompanhamento de 30 dias"] },
  { name: "Fechamento financeiro mensal", area: "Financeiro", status: "Ativo", steps: ["Consolidar vendas lançadas", "Conferir despesas", "Analisar indicadores", "Reunião de resultados"] },
  { name: "Campanha sazonal de vendas", area: "Marketing", status: "Rascunho", steps: ["Definir oferta", "Preparar materiais", "Treinar equipe", "Executar e medir"] },
];

const trainings = [
  { id: "tr1", title: "Atendimento que encanta", category: "Atendimento", duration: "2h 30min", modules: 6, level: "Essencial" },
  { id: "tr2", title: "Técnicas de vendas consultivas", category: "Vendas", duration: "3h", modules: 8, level: "Intermediário" },
  { id: "tr3", title: "Rotinas e checklists eficientes", category: "Processos", duration: "1h 20min", modules: 4, level: "Essencial" },
  { id: "tr4", title: "Comunicação e trabalho em equipe", category: "Comportamental", duration: "1h 45min", modules: 5, level: "Essencial" },
  { id: "tr5", title: "Indicadores e metas na prática", category: "Gestão", duration: "2h", modules: 6, level: "Avançado" },
  { id: "tr6", title: "Pós-venda e fidelização", category: "Vendas", duration: "1h 30min", modules: 4, level: "Intermediário" },
];

const feedbacks = [
  { id: "f1", companyId: "e1", collaboratorId: "c1", from: "Juliana Martins", date: "2026-10-15", type: "Elogio", text: "Excelente condução dos atendimentos desta semana. As clientes elogiaram muito o seu cuidado e a explicação dos protocolos." },
  { id: "f2", companyId: "e1", collaboratorId: "c1", from: "Juliana Martins", date: "2026-10-08", type: "Desenvolvimento", text: "Vamos reforçar a oferta de serviços complementares no fechamento. Sugiro revisar juntas a etapa de apresentação da solução no processo de atendimento." },
  { id: "f3", companyId: "e1", collaboratorId: "c2", from: "Juliana Martins", date: "2026-10-12", type: "Elogio", text: "Parabéns por bater a meta antes do dia 15! Sua organização na recepção fez diferença." },
  { id: "f4", companyId: "e1", collaboratorId: "c3", from: "Juliana Martins", date: "2026-10-10", type: "Desenvolvimento", text: "Precisamos melhorar a constância no checklist de fechamento. Conte comigo para ajustar a rotina." },
  { id: "f5", companyId: "e1", collaboratorId: "c4", from: "Juliana Martins", date: "2026-10-05", type: "Reconhecimento", text: "Ótima iniciativa ao organizar a campanha de indicação entre as colegas." },
  { id: "f6", companyId: "e1", collaboratorId: "c1", from: "Vanessa Nascimento (Consultora)", date: "2026-09-28", type: "Reconhecimento", text: "Na visita de consultoria, sua rotina de abertura foi destaque como modelo para a equipe." },
];

const SAMPLE_PROOFS = {
  "cl-c1-0": {
    0: { note: "Sistemas ligados e agenda conferida às 8h05.", status: "aprovada", date: "2026-10-18" },
    1: { note: "Salas higienizadas e recepção organizada.", status: "pendente", date: "2026-10-18" },
  },
  "cl-c2-0": { 0: { note: "Agenda do dia confirmada com todas as clientes.", status: "pendente", date: "2026-10-18" } },
};

export function buildSeed() {
  const collaborators = collabSeed.map(([id, companyId, name, role, goal]) => ({ id, companyId, name, role, goal }));
  const sales = collabSeed.flatMap(([id, companyId, , , goal, perf]) =>
    FACT.map((f, k) => ({ id: `s-${id}-${k}`, companyId, collaboratorId: id, date: `2026-10-${String(2 + k * 2).padStart(2, "0")}`, value: Math.round((goal * perf * f) / 80) * 10, note: "Total do dia" })),
  );
  const tasks = collaborators.flatMap((c, i) =>
    TIMES.map((time, k) => ({ id: `t-${c.id}-${k}`, companyId: c.companyId, collaboratorId: c.id, title: TASKS[(i + k) % TASKS.length], time, priority: PRIORITIES[k], done: k < (i % 3) + 1 })),
  );
  const checklists = collaborators.flatMap((c, i) =>
    CHECKLISTS.map((t, j) => ({ id: `cl-${c.id}-${j}`, companyId: c.companyId, collaboratorId: c.id, title: t.title, period: t.period, items: t.items.map((text, k) => ({ text, done: j === 0 ? k < 4 - (i % 2) : k < (i + j) % 3, proof: SAMPLE_PROOFS[`cl-${c.id}-${j}`]?.[k] })) })),
  );
  const processes = companies.flatMap((co, i) =>
    PROCESSES.slice(0, i === 0 ? 5 : 3 + (i % 2)).map((p, k) => ({ ...p, id: `p-${co.id}-${k}`, companyId: co.id, owner: co.owner })),
  );
  const progress = Object.fromEntries(collaborators.map((c, i) => [c.id, Object.fromEntries(trainings.map((t, j) => [t.id, ((i * 37 + j * 23) % 5) * 25]))]));
  return migrate({ companies, collaborators, sales, tasks, checklists, processes, trainings, progress, feedbacks });
}

export const VERSION = 7;

const TEMPLATES = [
  ...PROCESSES.map((p, i) => ({ id: `tpl-${i}`, name: p.name, area: p.area, role: "", steps: p.steps })),
  { id: "tpl-caixa", name: "Rotina da atendente de caixa", area: "Caixa", role: "Atendente de caixa", steps: ["Conferir fundo de troco", "Registrar vendas no sistema", "Controlar sangrias", "Fechar caixa e informar total do dia"] },
  { id: "tpl-vendedora", name: "Rotina da vendedora", area: "Comercial", role: "Vendedora", steps: ["Revisar metas do dia", "Contatar carteira de clientes", "Atender e apresentar produtos", "Registrar vendas e pós-venda"] },
  { id: "tpl-online", name: "Rotina da loja online", area: "Loja online", role: "Responsável pela loja online", steps: ["Responder mensagens e pedidos", "Atualizar estoque no site", "Separar e despachar pedidos", "Publicar novidades nas redes"] },
];

const T = (id, companyId, collaboratorId, title, frequency, dueDate, extra = {}) => ({
  id, companyId, collaboratorId, teamRole: null, title, frequency, dueDate, time: "09:00", priority: "Média", status: "pendente", done: false, requiresApproval: false, processId: null, history: [], ...extra,
});

const EXTRA_TASKS = [
  T("rt-1", "e1", "c1", "Revisar estoque de cosméticos da sala", "semanal", "2026-10-17", { priority: "Alta", processId: "p-e1-1" }),
  T("rt-2", "e1", "c1", "Preparar protocolo da campanha de novembro", "pontual", "2026-10-25", { requiresApproval: true, processId: "p-e1-4" }),
  T("rt-3", "e1", "c1", "Organizar fichas de protocolos realizados", "pontual", "2026-10-18", { requiresApproval: true, status: "aguardando", history: [{ date: "2026-10-18", by: "Ana Clara Rocha", text: "Concluída · aguardando aprovação" }] }),
  T("rt-4", "e1", "c2", "Conferir caixa de abertura", "diaria", "2026-10-18", { time: "08:00", priority: "Alta", processId: "p-e1-0" }),
  T("rt-5", "e1", "c2", "Relatório de agendamentos do mês", "mensal", "2026-10-31", { requiresApproval: true, time: "17:00" }),
  T("rt-6", "e1", "c3", "Higienização profunda das macas", "semanal", "2026-10-16", { priority: "Alta" }),
  T("rt-7", "e1", "c4", "Responder leads do Instagram e WhatsApp", "diaria", "2026-10-18", { time: "11:00", processId: "p-e1-0", status: "andamento" }),
  T("rt-8", "e1", "c4", "Atualizar vitrine da loja online", "semanal", "2026-10-20", { time: "15:00" }),
  T("rt-9", "e1", null, "Reunião de alinhamento semanal", "semanal", "2026-10-20", { teamRole: "*", time: "08:00" }),
  T("rt-10", "e1", null, "Calibrar equipamentos de estética", "mensal", "2026-10-30", { teamRole: "Esteticista" }),
  T("rt-11", "e2", "c5", "Fechar caixa e informar total do dia", "diaria", "2026-10-18", { time: "18:00" }),
  T("rt-12", "e2", "c6", "Contatar clientes da carteira", "semanal", "2026-10-15", { priority: "Alta" }),
  T("rt-13", "e4", "c12", "Confirmar agenda do dia seguinte", "diaria", "2026-10-18", { time: "17:30" }),
];

const G = (id, companyId, collaboratorId, title, metric, target, unit = "%", current = 0) => ({ id, companyId, collaboratorId, title, metric, target, unit, current });
const GOALS = [
  G("g-1", "e1", null, "Conclusão das tarefas da equipe", "tarefas", 90),
  G("g-2", "e1", null, "Checklists completos", "checklists", 95),
  G("g-3", "e1", null, "Avaliações 5 estrelas no Google", "manual", 40, "avaliações", 26),
  G("g-4", "e1", "c1", "Pós-vendas realizados em 48h", "manual", 30, "contatos", 18),
  G("g-5", "e1", "c1", "Minhas tarefas concluídas", "tarefas", 85),
  G("g-6", "e2", null, "Conclusão das tarefas da equipe", "tarefas", 85),
  G("g-7", "e3", null, "Conclusão das tarefas da equipe", "tarefas", 85),
  G("g-8", "e4", null, "Conclusão das tarefas da equipe", "tarefas", 85),
];

function toV4(s) {
  const companyIds = new Set(s.companies.map((c) => c.id));
  const collabIds = new Set(s.collaborators.map((c) => c.id));
  const processIds = new Set(s.processes.map((p) => p.id));
  const known = new Set(s.tasks.map((t) => t.id));
  const valid = (x) => companyIds.has(x.companyId) && (!x.collaboratorId || collabIds.has(x.collaboratorId));
  const norm = (t) => ({ frequency: "diaria", dueDate: TODAY, status: t.done ? "concluida" : "pendente", requiresApproval: false, processId: null, teamRole: null, history: [], ...t });
  const extra = EXTRA_TASKS.filter((t) => valid(t) && !known.has(t.id)).map((t) => ({ ...t, processId: processIds.has(t.processId) ? t.processId : null }));
  return {
    ...s,
    v: 4,
    tasks: [...s.tasks.map(norm), ...extra],
    processes: s.processes.map((p) => ({ role: "", responsibleId: null, ...p })),
    templates: s.templates || TEMPLATES,
    goals: s.goals || GOALS.filter(valid),
  };
}

const OPERATIONAL_TASKS = new Set(["rt-1", "rt-6", "rt-8", "rt-10"]);

const toV5 = (s) => ({
  ...s,
  v: 5,
  tasks: s.tasks.map((t) => ({ ...t, kind: t.kind || (OPERATIONAL_TASKS.has(t.id) ? "operacional" : "administrativo") })),
  checklists: s.checklists.map((cl) => ({ ...cl, kind: cl.kind || (/fechamento/i.test(cl.title) ? "administrativo" : "operacional") })),
});

const ABSENCES = [
  { id: "ab-1", companyId: "e1", collaboratorId: "c3", type: "falta", start: "2026-10-09", end: "2026-10-09", note: "Não avisou" },
  { id: "ab-2", companyId: "e1", collaboratorId: "c4", type: "atestado", start: "2026-10-14", end: "2026-10-15", note: "Atestado médico" },
  { id: "ab-3", companyId: "e1", collaboratorId: "c2", type: "ferias", start: "2026-10-19", end: "2026-10-28", note: "Férias programadas" },
  { id: "ab-4", companyId: "e1", collaboratorId: "c1", type: "folga", start: "2026-10-03", end: "2026-10-03", note: "Banco de horas" },
  { id: "ab-5", companyId: "e2", collaboratorId: "c6", type: "falta", start: "2026-10-07", end: "2026-10-07", note: "" },
  { id: "ab-6", companyId: "e4", collaboratorId: "c10", type: "ferias", start: "2026-10-12", end: "2026-10-16", note: "" },
];

const hm = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

const buildTimeEntries = (collabs) =>
  collabs.flatMap((c, i) =>
    Array.from({ length: 17 }, (_, k) => k + 1)
      .filter((d) => new Date(2026, 9, d).getDay() !== 0)
      .map((d) => ({ d, date: `2026-10-${String(d).padStart(2, "0")}` }))
      .filter(({ date }) => !ABSENCES.some((a) => a.collaboratorId === c.id && date >= a.start && date <= a.end))
      .map(({ d, date }) => ({
        id: `te-${c.id}-${d}`,
        companyId: c.companyId,
        collaboratorId: c.id,
        date,
        events: [{ type: "inicio", time: hm(530 + ((i * 7 + d * 3) % 26)) }, { type: "pausa", time: "12:00" }, { type: "retorno", time: "13:00" }, { type: "termino", time: hm(1080 + ((i + d) % 4) * 5) }],
      })),
  );

const toV6 = (s) => {
  const ids = new Set(s.collaborators.map((c) => c.id));
  return {
    ...s,
    v: 6,
    timeEntries: s.timeEntries || buildTimeEntries(s.collaborators.filter((c) => /^c\d+$/.test(c.id))),
    absences: s.absences || ABSENCES.filter((a) => ids.has(a.collaboratorId)),
  };
};

const COMPANY_DATES = { e1: ["2019-10-25", "1987-11-02"], e2: ["2018-10-30", "1985-10-20"], e3: ["2021-01-15", "1990-12-05"], e4: ["2017-11-08", "1983-10-28"] };
const COLLAB_BDAYS = { c1: "1998-10-18", c2: "1995-10-21", c3: "1992-11-10", c4: "1990-03-14", c5: "1996-10-24", c6: "1999-07-02", c7: "1988-11-01", c8: "1994-10-19", c9: "1997-05-23", c10: "1991-11-12", c11: "2000-10-29", c12: "1993-09-09" };

const toV7 = (s) => ({
  ...s,
  v: 7,
  companies: s.companies.map((c) => ({ foundedAt: COMPANY_DATES[c.id]?.[0] || "", ownerBirthday: COMPANY_DATES[c.id]?.[1] || "", ...c })),
  collaborators: s.collaborators.map((c) => ({ birthday: COLLAB_BDAYS[c.id] || "", ...c })),
});

export const MAINT_CATEGORIES = ["Estrutura", "Equipamentos", "Elétrica", "Hidráulica", "Climatização", "Segurança", "Limpeza pesada", "Outros"];
export const ACCESS_CATEGORIES = ["Wi-Fi", "Notebook / Computador", "Sistema", "Alarme", "Câmeras", "E-mail", "Redes sociais", "Banco", "Outros"];

const M = (id, companyId, category, name, frequency, last, extra = {}) => ({ id, companyId, category, name, frequency, assigneeId: null, lastCheck: last, history: last ? [last] : [], ...extra });
const ck = (date, status, by, note = "") => ({ date, status, by, note });
const MAINTENANCE = [
  M("mt-1", "e1", "Estrutura", "Paredes, pintura e teto das salas", "mensal", ck("2026-10-01", "ok", "Beatriz Nunes")),
  M("mt-2", "e1", "Equipamentos", "Aparelho de radiofrequência", "semanal", ck("2026-10-14", "ok", "Beatriz Nunes")),
  M("mt-3", "e1", "Equipamentos", "Macas elétricas (motor e estofado)", "semanal", ck("2026-10-16", "problema", "Beatriz Nunes", "Maca da sala 2 com rasgo no estofado.")),
  M("mt-4", "e1", "Climatização", "Limpeza dos filtros do ar-condicionado", "mensal", ck("2026-09-10", "ok", "Beatriz Nunes")),
  M("mt-5", "e1", "Elétrica", "Tomadas, lâmpadas e disjuntores", "mensal", ck("2026-10-05", "ok", "Beatriz Nunes")),
  M("mt-6", "e1", "Segurança", "Extintores (validade e lacre)", "trimestral", ck("2026-08-20", "ok", "Beatriz Nunes")),
  M("mt-7", "e1", "Hidráulica", "Pias, torneiras e descargas", "semanal", null, { assigneeId: "c1" }),
  M("mt-8", "e2", "Estrutura", "Provadores e espelhos", "semanal", ck("2026-10-15", "ok", "Elaine Costa")),
  M("mt-9", "e2", "Equipamentos", "Máquinas de costura", "mensal", ck("2026-09-02", "ok", "Helena Duarte")),
  M("mt-10", "e3", "Equipamentos", "Forno e batedeiras industriais", "semanal", ck("2026-10-17", "ok", "Isabela Ramos")),
  M("mt-11", "e3", "Climatização", "Câmara fria (temperatura e vedação)", "diaria", ck("2026-10-18", "ok", "Isabela Ramos")),
  M("mt-12", "e4", "Equipamentos", "Secadores e chapinhas", "semanal", ck("2026-10-03", "problema", "Olívia Santos", "Secador da bancada 3 desarmando.")),
];

const A = (id, companyId, category, name, login, password, extra = {}) => ({ id, companyId, category, name, login, password, url: "", note: "", ...extra });
const ACCESSES = [
  A("ac-1", "e1", "Wi-Fi", "Wi-Fi Clientes", "BellaEstetica_Clientes", "bella2026"),
  A("ac-2", "e1", "Wi-Fi", "Wi-Fi Interno", "BellaEstetica_Equipe", "Eq#9921x"),
  A("ac-3", "e1", "Notebook / Computador", "Notebook da recepção", "recepcao", "Rcp@2026"),
  A("ac-4", "e1", "Sistema", "Sistema de agendamento", "juliana@bellaestetica.com", "Agenda!77", { url: "https://exemplo-agenda.com" }),
  A("ac-5", "e1", "Alarme", "Alarme da loja", "Código de desarme", "4821", { note: "Central monitorada: (11) 0000-0000" }),
  A("ac-6", "e1", "Redes sociais", "Instagram @bellaestetica", "@bellaestetica", "Insta#2026"),
  A("ac-7", "e2", "Wi-Fi", "Wi-Fi Ateliê", "FlorDeLis", "flor1234"),
  A("ac-8", "e3", "Alarme", "Alarme da confeitaria", "Código", "7310"),
  A("ac-9", "e4", "Sistema", "Sistema do caixa", "caixa01", "Glam@01"),
];

const E = (id, owner, title, date, time, type, note = "") => ({ id, owner, title, date, time, type, note });
const EVENTS = [
  E("ev-1", "master", "Visita de consultoria · Bella Estética", "2026-10-20", "09:00", "Visita"),
  E("ev-2", "master", "Reunião de resultados · Studio Glam", "2026-10-22", "14:00", "Reunião", "Revisar metas e selo de qualidade"),
  E("ev-3", "master", "Fechar relatórios mensais", "2026-10-30", "10:00", "Lembrete"),
  E("ev-4", "master", "Mentoria em grupo das empresárias", "2026-10-18", "19:00", "Compromisso"),
  E("ev-5", "e1", "Reunião de equipe", "2026-10-20", "08:00", "Reunião"),
  E("ev-6", "e1", "Técnico do ar-condicionado", "2026-10-21", "15:00", "Compromisso", "Manutenção preventiva"),
  E("ev-7", "e1", "Pagar fornecedores", "2026-10-25", "10:00", "Lembrete"),
  E("ev-8", "e1", "Ação Outubro Rosa", "2026-10-18", "10:00", "Compromisso"),
  E("ev-9", "e2", "Chegada da nova coleção", "2026-10-23", "11:00", "Compromisso"),
];

const SERVICES = { e1: "Limpeza de pele, drenagem, protocolos faciais e corporais", e2: "Moda feminina, ajustes e consultoria de estilo", e3: "Bolos, doces finos e mesas de festa", e4: "Corte, coloração, manicure e penteados" };
const SEALS = { e1: { level: "bronze", month: "2026-09", approvedAt: "2026-10-02" }, e3: { level: "prata", month: "2026-09", approvedAt: "2026-10-02" } };

const toV8 = (s) => {
  const ids = new Set(s.companies.map((c) => c.id));
  const mine = (x) => ids.has(x.companyId);
  return {
    ...s,
    v: 8,
    companies: s.companies.map((c) => ({ services: SERVICES[c.id] || "", maintenanceResponsibleId: c.id === "e1" ? "c2" : null, ...c })),
    collaborators: s.collaborators.map((c) => ({ accessAllowed: c.id === "c1", ...c })),
    maintenance: s.maintenance || MAINTENANCE.filter(mine),
    accesses: s.accesses || ACCESSES.filter(mine),
    events: s.events || EVENTS.filter((e) => e.owner === "master" || ids.has(e.owner)),
    seals: s.seals || Object.fromEntries(Object.entries(SEALS).filter(([k]) => ids.has(k))),
    referrals: s.referrals || [],
  };
};

export function migrate(s) {
  let x = (s.v || 0) < 4 ? toV4(s) : s;
  if (x.v < 5) x = toV5(x);
  if (x.v < 6) x = toV6(x);
  if (x.v < 7) x = toV7(x);
  if (x.v < 8) x = toV8(x);
  return x;
}
